var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClipboardIc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 857.49995 980",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "clipboard") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_3",
    "data-name": 3
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M714.4,10H346.9c-64.8,0-122.5,59.4-122.5,122.5l-35.4.8c-64.8,0-117.7,58.6-117.7,121.7V867.5C71.3,930.6,129,990,193.8,990H653.2c64.8,0,122.5-59.4,122.5-122.5h30.6c64.8,0,122.5-59.4,122.5-122.5V255.7ZM653.1,928.8H193.8c-32.2,0-61.3-30-61.3-61.3V255c0-31.2,26.2-60.2,58.3-60.2l33.5-1V745c0,63.1,57.7,122.5,122.5,122.5H714.3C714.4,898.7,685.3,928.8,653.1,928.8ZM867.5,745c0,31.2-29.1,61.2-61.3,61.2H346.9c-32.2,0-61.3-30-61.3-61.2V132.5c0-31.2,29.1-61.3,61.3-61.3h306.3c-.5,70.5,0,123.3,0,123.3,0,63.6,57.3,121.7,122.5,121.7h91.9V745ZM775.6,255c-32.6,0-61.3-59.3-61.3-91V72.1L867.5,255ZM714.4,439.3H438.8a30.6,30.6,0,1,0,0,61.2H714.4a30.6,30.6,0,0,0,0-61.2Zm0,153H438.8a30.6,30.6,0,1,0,0,61.2H714.4a30.6,30.6,0,1,0,0-61.2Z",
    transform: "translate(-71.30003 -10)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboardIc);
export default __webpack_public_path__ + "static/media/clipboard-ic.0c9abed97041ac74efd1684cea125d22.svg";
export { ForwardRef as ReactComponent };